export const LogEvents = {
  SignIn: {
    name: "User Signed In",
    channel: "login",
  },
  SignOut: {
    name: "User Signed Out",
    channel: "login",
  },
  PlatformJump: {
    name: "User Clicked Platform Login Button",
    channel: "website",
  },
};
